import { Pipe, PipeTransform } from "@angular/core";
import { formatEnumString } from "../pipe-enum-utils";

@Pipe({
  name: "enumDisplay",
})
export class EnumDisplayPipe implements PipeTransform {
  transform(value: number, enumType: any): any {
    let t = enumType[value] as string;
    if (!t) {
      return "";
    }

    return formatEnumString(t);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/enum-display.pipe.ts